/** Full-screen skeleton shown while auth state resolves — prevents the
 *  login-flash "ghost" during token refresh (frontend-patterns §3.2.1). */
export function AppInitializing({ message = 'Loading…' }: { message?: string }) {
  return (
    <div className="app-initializing">
      <div className="app-initializing-content">
        <div className="skeleton skeleton-logo" aria-hidden="true" />
        <div className="loading-spinner" role="status" aria-label="Loading" />
        <p className="loading-message">{message}</p>
      </div>
    </div>
  );
}
